import React, { useState, useEffect } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import * as XLSX from "xlsx";
import { IconFileDownload, IconSearch } from "@tabler/icons";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";

import "./style.css";
import ReportService from "src/service/reports";
import moment from "moment";
import VehicleDetailsService from "src/service/vehicleDetails";
import { writeFile } from "xlsx";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

import jsPDF from "jspdf";
import "jspdf-autotable";
import LogoService from "src/service/logoService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Performance Report",
  },
];

const PerformanceReportVehiclewise = () => {
  const [performance_report, setPerfromanceReport] = useState([]);
  const [vehicle_list, setvehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [loading, setLoading] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const [from_date, setFromDate] = useState(today);
  const [to_date, setToDate] = useState(today);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [export_data, setExportData] = useState([]);

  const [logo_data, setLogodata] = useState([]);

  const fetch_logo_data = async () => {
    try {
      const res = await LogoService.getLogoList();
      setLogodata(res.data[0]);
      console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_logo_data();
  }, []);

  useEffect(() => {
    const fetchVehicleNoData = async () => {
      try {
        const res = await VehicleDetailsService.fetch_distict_vehicle({
          vehicle_type: sessionData?.data?.vehicle_type || "",
          district_id: sessionData?.data?.district_id || "",
          user_type: sessionData?.data?.user_type || "",
          user_id: sessionData?.data?.id || "",
        });
        setvehicleList(res.data);
        if (res.data.length > 0) {
          const defaultVehicle = res.data[0].vehicle_no;
          setSelectedVehicle(defaultVehicle);
          fetch_vehiclePerformance_report(defaultVehicle);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchVehicleNoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch_vehiclePerformance_report = async (
    vehicle_no = selectedVehicle
  ) => {
    setLoading(true); // Start loading
    try {
      const res = await ReportService.getVehiclewisePerformanceReport({
        vehicle_no: vehicle_no,
        from_date: from_date,
        to_date: to_date,
      });
      console.log("performance data===", res);
      setPerfromanceReport(res.data);
      setExportData(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Call fetch_vehiclePerformance_report when selectedVehicle, from_date, or to_date changes
  useEffect(() => {
    if (selectedVehicle) {
      fetch_vehiclePerformance_report();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchClick = () => {
    fetch_vehiclePerformance_report(selectedVehicle, from_date, to_date);
  };

  const exportVisibleDataToExcel = () => {
    const headers = [
      "Sl. No",
      "Vehicle No",
      "District Name",
      "ERV No",
      "Start Date Time",
      "End Date Time",
      "Movement(Hrs)",
      "Idle (Hrs)",
      "Travel Distance (Km)",
      "Avg Speed (Km/H)",
      "Top speed (Km/H)",
    ];

    const data = export_data.map((man, index) => [
      index + 1,
      man?.vehicle_no,
      man?.district_name,
      man?.erv_no !== null && man?.erv_no !== "ABC" ? man.erv_no : "NA",
      man.timePeriod?.startTime,
      man.timePeriod?.endTime,
      man.running_time,
      man.total_idle_time,
      man.distance,
      man.avg_speed,
      man.top_speed,
    ]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "Performance Report.xlsx";

    writeFile(wb, fileName);
  };

  const paginatedData = performance_report.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // --------------------------
  // const exportVisibleDataToPDF = () => {
  //   const doc = new jsPDF("landscape");
  //   const headers1 = ["Sl. No", "Amazone"];
  //   const headers = [
  //     "Sl. No",
  //     "Vehicle No",
  //     "Start Date Time",
  //     "End Date Time",
  //     "Movement (Hrs)",
  //     "Idle (Hrs)",
  //     "Travel Distance (Km)",
  //     "Avg Speed (Km/H)",
  //     "Top speed (Km/H)",
  //   ];

  //   const data = performance_report.map((item, index) => [
  //     index + 1 + page * rowsPerPage,
  //     item?.vehicle_no || "NA",
  //     item?.timePeriod?.startTime
  //       ? moment(item?.timePeriod?.startTime).format("DD-MM-YYYY hh:mm:ss a")
  //       : "NA",
  //     item?.timePeriod?.endTime
  //       ? moment(item?.timePeriod?.endTime).format("DD-MM-YYYY hh:mm:ss a")
  //       : "NA",
  //     item?.running_time || "NA",
  //     item?.total_idle_time || "NA",
  //     item?.distance || "NA",
  //     item?.avg_speed || "NA",
  //     item?.top_speed || "NA",
  //   ]);

  //   doc.autoTable({
  //     head: [headers],
  //     body: data,
  //     startY: 20,
  //     margin: { horizontal: 10 },
  //     headStyles: { fillColor: [44, 62, 80] },
  //     styles: { cellPadding: 5, fontSize: 10 },
  //   });

  //   doc.save("Performance Report.pdf");
  // };

  const exportVisibleDataToPDF = async () => {
    const doc = new jsPDF("landscape");

    const logoUrl = logo_data?.logo; // Bitbucket path to the logo
    let base64Logo = "";

    // Function to fetch and convert image to base64
    function getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
      });
    }

    try {
      base64Logo = await getBase64ImageFromURL(logoUrl);
    } catch (error) {
      console.error("Error fetching the logo image:", error);
    }

    // First Header Data
    const firstHeader = [
      [
        {
          content: base64Logo
            ? { image: base64Logo, width: 80, height: 30 }
            : "",
          colSpan: 2,
          styles: { halign: "left", valign: "middle" },
        },
        {
          content: logo_data?.header_name || "Company Name",
          colSpan: 3,
          styles: { fontSize: 20, valign: "middle" },
        },
      ],
    ];

    // Second Header Data
    const headers = [
      "Sl. No",
      "Vehicle No",
      "District Name",
      "ERV No",
      "Start Date Time",
      "End Date Time",
      "Movement (Hrs)",
      "Idle (Hrs)",
      "Travel Distance (Km)",
      "Avg Speed (Km/H)",
      "Top speed (Km/H)",
    ];

    const data = performance_report.map((item, index) => [
      index + 1 + page * rowsPerPage,
      item?.vehicle_no || "NA",
      item?.district_name,
      item?.erv_no !== null && item?.erv_no !== "ABC" ? item.erv_no : "NA",
      item?.timePeriod?.startTime
        ? moment(item?.timePeriod?.startTime).format("DD-MM-YYYY hh:mm:ss a")
        : "NA",
      item?.timePeriod?.endTime
        ? moment(item?.timePeriod?.endTime).format("DD-MM-YYYY hh:mm:ss a")
        : "NA",
      item?.running_time || "NA",
      item?.total_idle_time || "NA",
      item?.distance || "NA",
      item?.avg_speed || "NA",
      item?.top_speed || "NA",
    ]);

    // Add the first header to the PDF
    doc.autoTable({
      head: firstHeader,
      startY: 20,
      margin: { horizontal: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      styles: { cellPadding: 5, fontSize: 10 },
    });

    // Add the second header (column headers) and the table data to the PDF
    doc.autoTable({
      head: [headers],
      body: data,
      startY: doc.autoTable.previous.finalY, // Start right after the first header
      margin: { horizontal: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      styles: { cellPadding: 5, fontSize: 10 },
    });

    doc.save("Performance Report.pdf");
  };

  // ----------------------------

  return (
    <PageContainer
      title="Performance Report"
      description="this is Basic Table page"
    >
      <Breadcrumb title="Vehicle Day Wise Performance Report" items={BCrumb} />

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CustomFormLabel>
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_no"
                name="vehicle_no"
                options={vehicle_list}
                getOptionLabel={(option) => option.vehicle_no}
                value={
                  vehicle_list.find(
                    (option) => option.vehicle_no === selectedVehicle
                  ) || null
                }
                onChange={(event, newValue) =>
                  setSelectedVehicle(newValue ? newValue.vehicle_no : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Vehicle No"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="from_date">
                From Date <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="from_date"
                name="from_date"
                type="date"
                value={from_date}
                onChange={(e) => setFromDate(e.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="to_date">
                To Date <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="to_date"
                name="to_date"
                type="date"
                value={to_date}
                onChange={(e) => setToDate(e.target.value)}
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button onClick={handleSearchClick} style={{ padding: "10px" }}>
                <IconSearch />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={exportVisibleDataToExcel}
                style={{ padding: "10px" }}
              >
                <IconFileDownload width={20} />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={exportVisibleDataToPDF}
                style={{ padding: "10px" }}
              >
                <PictureAsPdfIcon />
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "",
              }}
            >
              <TableHead style={{ backgroundColor: "silver" }}>
                <TableRow>
                  <TableCell colSpan={2}>
                    <img src={logo_data?.logo} alt="" width={80} />
                  </TableCell>
                  <TableCell colSpan={9}>
                    <Typography
                      style={{ fontSize: "20px", textAlign: "center" }}
                      variant="h5"
                    >
                      {logo_data?.header_name}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead style={{ backgroundColor: "silver" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      District Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      ERV No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Start DateTime
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      End DateTime
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Movement (Hrs)
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Idle (Hrs)
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Travel Distance (Km)
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Avg Speed (Km/H)
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Top Speed (Km/H)
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Start Location
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Last Location
                    </Typography>
                  </TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={9} style={{ textAlign: "center" }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : paginatedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {index + 1 + page * rowsPerPage}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.vehicle_no !== null ? item.vehicle_no : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item?.district_name !== null
                            ? item?.district_name
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item?.erv_no !== null && item?.erv_no !== "ABC"
                            ? item.erv_no
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item?.timePeriod?.startTime !== null
                            ? moment(item?.timePeriod?.startTime).format(
                                "DD-MM-YYYY hh:mm:ss a"
                              )
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item?.timePeriod?.endTime !== null
                            ? moment(item?.timePeriod?.endTime).format(
                                "DD-MM-YYYY hh:mm:ss a"
                              )
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.running_time !== null
                            ? item.running_time
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.total_idle_time !== null
                            ? item.total_idle_time
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.distance !== null ? item.distance : "NA"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.avg_speed !== null ? item.avg_speed : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.top_speed !== null ? item.top_speed : "NA"}
                        </Typography>
                      </TableCell>
                      {/* <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.firstLocationName !== null
                            ? item.firstLocationName
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.lastLocationName !== null
                            ? item.lastLocationName
                            : "NA"}
                        </Typography>
                      </TableCell> */}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100, 250, 500]}
            component="div"
            count={performance_report.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default PerformanceReportVehiclewise;
